var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParentElementArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.516167,
    y: 0.516167,
    width: 16.9677,
    height: 16.9677,
    rx: 8.48383,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 17.4677 -4.51248e-08)",
    fill: "#01A3E3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.516167,
    y: 0.516167,
    width: 16.9677,
    height: 16.9677,
    rx: 8.48383,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 17.4677 -4.51248e-08)",
    stroke: "white",
    strokeWidth: 1.03233
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90809 11.8737L11.4489 9.33293C11.5005 9.28132 11.5376 9.22667 11.56 9.16898C11.5825 9.1113 11.5937 9.04977 11.5937 8.98437C11.5937 8.91899 11.5825 8.85745 11.56 8.79977C11.5376 8.74209 11.5005 8.68745 11.4489 8.63583L8.89932 6.08625C8.80276 5.98969 8.68511 5.94141 8.54639 5.94141C8.40767 5.94141 8.29003 5.98969 8.19346 6.08625C8.09689 6.18281 8.05007 6.30192 8.053 6.44357C8.05592 6.5852 8.10566 6.70431 8.20223 6.80087L10.3857 8.98437L8.19346 11.1766C8.09689 11.2732 8.04861 11.3894 8.04861 11.5252C8.04861 11.661 8.09689 11.7772 8.19346 11.8737C8.29003 11.9703 8.40913 12.0186 8.55077 12.0186C8.69241 12.0186 8.81152 11.9703 8.90809 11.8737Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentElementArrowIcon);
export default __webpack_public_path__ + "static/media/parentElementArrowIcon.ae6b57ad.svg";
export { ForwardRef as ReactComponent };